// extracted by mini-css-extract-plugin
export default {"brandAvatar":"Avatar_brandAvatar__b3Ai6"};